import React from 'react';
import { Icon } from '@livable/saas-react-components';
import { IconButton } from '@mui/material';
import useStyles from './billsFilterPanelStyles';

/**
 * A column's funnel (LB-6087). The same one on every column that can be filtered, opening the filter panel at that
 * column's filter, and filled while the filter is on. It used to be two different icons on two columns, each with a
 * menu of its own.
 */
export function BillsHeaderFilterButton(_ref) {
  let categoryKey = _ref.categoryKey,
    isActive = _ref.isActive,
    isExpanded = _ref.isExpanded,
    label = _ref.label,
    onOpen = _ref.onOpen;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(IconButton, {
    size: "small"
    // The fill says the filter is on to the eye; the name says it to everyone else.
    ,
    "aria-label": isActive ? "".concat(label, " (on)") : label,
    "aria-haspopup": "dialog",
    "aria-expanded": isExpanded ? 'true' : 'false',
    "aria-controls": isExpanded ? 'bills-filter-panel' : undefined,
    className: "".concat(classes.headerFilterButton, " ").concat(isActive ? classes.headerFilterButtonActive : ''),
    onClick: event => onOpen(event.currentTarget, categoryKey),
    'custom-attribute': "bills-filter-header-".concat(categoryKey)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "filter-new"
  }));
}